import { render, staticRenderFns } from "./StudioOverview.vue?vue&type=template&id=7dfa2c1c"
import script from "./StudioOverview.vue?vue&type=script&lang=js"
export * from "./StudioOverview.vue?vue&type=script&lang=js"
import style0 from "./StudioOverview.vue?vue&type=style&index=0&id=7dfa2c1c&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports